import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { useCallback } from 'react';
import { addAvailabilityAction, fetchAvailabilitiesAction } from 'redux/slices/iCalendarV4/availabilitySlice';

import { closeNestedDialogAction } from 'redux/slices/nestedDialogSlice';
import MyAvailabilityForm from './MyAvailabilityForm';

const MyAvailabilityCreate = (props) => {
    const { userData, type, onSubmit } = props;
    const { userGroupId } = userData;
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const loadData = useCallback(() => {
        dispatch(
            fetchAvailabilitiesAction({
                queryParams: {
                    calendarId: userData.userId,
                    expand: ['services'],
                },
            }),
        );
    }, [dispatch, userData.userId]);

    const handleSubmit = (payload, callbackOk, callbackError) => {
        if (onSubmit) {
            onSubmit(payload, callbackOk, callbackError);
        } else {
            dispatch(
                addAvailabilityAction({
                    dto: { ...payload, calendarId: userData.userId },
                    options: { useState: false },
                    onSuccess: () => {
                        loadData();
                        callbackOk?.();
                        close();
                    },
                    onFailure: (error) => callbackError?.(error),
                }),
            );
        }
    };

    const close = () => {
        dispatch(closeNestedDialogAction());
    };

    return (
        <MyAvailabilityForm
            type={type}
            onSubmit={handleSubmit}
            title={t('profile.myAvailability.form.createTitle')}
            onClose={close}
            userGroupId={userGroupId}
        />
    );
};

export default MyAvailabilityCreate;
